module.exports = __webpack_public_path__ + "static/img/home_footer_book.486e946.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_footer_book.png
// module id = WtOO
// module chunks = 34